<template>
  <div>
    <v-radio-group v-model="form.iga.value" :disabled="disabled">
      <v-row
        :class="$vuetify.breakpoint.smAndDown ? 'table-iga' : 'table-iga mr-6'"
        v-for="option in igaOptions"
        :key="option.value"
      >
        <v-col cols="1">
          <v-radio :value="option.value" />
        </v-col>
        <v-col cols="2">
          <div class="d-flex align-center justify-start">{{ option.value }}</div>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 8 : 3">
          <div class="d-flex align-center justify-start">{{ option.intensity }}</div>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
          <div class="d-flex align-center justify-start">{{ option.description }}</div>
        </v-col>
      </v-row>
    </v-radio-group>
    <v-row class="justify-center mt-6">
      <v-col cols="11">
        <ol>
          <li>
            Pacientes com lesões intensamente vermelhas, elevadas e liquenificadas mas limitadas em extensão, devem ser
            considerados Moderados - 3.
          </li>
          <li>Escoriações não são avaliadas nessa escala</li>
        </ol>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="11">
        <p>
          Referência:
          <a
            href="https://www.eczemacouncil.org/assets/docs/Validated-Investigator-Global-Assessment-Scale_vIGA-AD_2017.pdf"
            target="_blank"
          >
            https://www.eczemacouncil.org/assets/docs/Validated-Investigator-Global-Assessment-Scale_vIGA-AD_2017.pdf
          </a>
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { cloneDeep } from 'lodash'

const { mapActions: newAttendanceFormActions, mapMutations: newAttendanceFormMutations } =
  createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'IgaParameterNode',
  async created() {
    const { questions } = (await this.getParameter('atopic-dermatitis:iga')) ?? {}
    if (questions) {
      this.form = cloneDeep(questions)
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...newAttendanceFormActions(['getParameter']),
    ...newAttendanceFormMutations(['updateParameter']),
  },
  computed: {
    igaOptions() {
      return [
        {
          value: 0,
          intensity: 'Sem lesões',
          description: 'Pode ter hiper ou hipopigmentação pós inflamatória.',
        },
        {
          value: 1,
          intensity: 'Praticamente sem lesões',
          description: 'Eritema, pápulas e/ou liquenificação quase imperceptíveis. Sem crostas ou exsudação.',
        },
        {
          value: 2,
          intensity: 'Leve',
          description: 'Eritema, pápulas e/ou liquenificação presentes. Sem crostas ou exsudação.',
        },
        {
          value: 3,
          intensity: 'Moderado',
          description: 'Eritema, pápulas e/ou liquenificação claramente visíveis. Pode ter exsudação e crostas.',
        },
        {
          value: 4,
          intensity: 'Grave',
          description: 'Eritema, pápulas e/ou liquenificação intensos. Pode ter exsudação e crostas e doença extensa.',
        },
      ]
    },
  },
  data() {
    return {
      form: {
        iga: {
          value: null,
        },
      },
    }
  },
  watch: {
    form: {
      handler(value) {
        this.updateParameter({
          parameter: 'atopic-dermatitis:iga',
          value: { score: value.iga.value, questions: value },
        })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.table-iga div {
  align-items: center;
}

.table-iga div:nth-child(1n + 2) {
  border: solid 1px rgba(0, 0, 0, 0.7);
  margin-right: -1px;
  margin-bottom: -1px;
}

.table-iga div:first-child {
  justify-content: flex-end;
}

.table-iga div div {
  height: 100px;
}

.rate-ten > div {
  align-self: center;
  width: fit-content;
  border: 1px solid black;
  padding: 12px 24px;
}

@media (max-width: 425px) {
}
</style>
